import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "A Geomatician",
          "A GIS & Software developer",
          "A Data analyst",
          "A Water and Forest engineer",
          "A Soil scientist",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
